<template lang="pug">
.pendencias-tecnico
  .cabecalho.row.ac.col-s
    h3 TÉCNICOS COM ATIVIDADE REPRESADA
    span.sub Atividades presentes sem técnico por causa do cadastro de login V.texp. Recalculado a cada carga; a matrícula some assim que o login é cadastrado ou vinculado.
    Button.atualizar(layout="green-go white" @click="carregar" :loader="carregando") ATUALIZAR
  Loader(v-if="carregando" layout="small")
  .vazio(v-else-if="!lista.length")
    b Nenhum técnico com atividade represada.
    span Todas as atividades presentes com matrícula têm login vinculado.
  .lista(v-else)
    .pendencia.row.ac.col-s(v-for="p in lista" :key="p.matricula" :class="{ 'sem-acao': semAcao(p) }")
      .g3.g12-s.col
        label Técnico (V.tal)
        b {{ p.matricula }} · {{ p.nome_vtexp }}
        small {{ p.telefone }}
        small.login(v-if="p.id_vtexp_doutor") Login {{ p.id_vtexp_doutor }}{{ p.nome_doutor ? ' · ' + p.nome_doutor : '' }}
      .g2.g12-s.col
        label Atividades
        b.numero {{ p.sas }}
        small {{ p.jobs_parados }} job(s) parado(s)
      .g2.g12-s.col
        label Agendas
        b {{ p.primeira_agenda | date }} a {{ p.ultima_agenda | date }}
        small {{ p.cidades.join(', ') }}
      .g3.g12-s.col
        label Situação
        b.situacao {{ rotulo(p.situacao) }}
        small.motivo {{ p.motivo }}
        small.dono
          | Quem resolve:&nbsp;
          b {{ p.dono }}
      .g2.g12-s.row.je.ac
        Button.cadastrar(v-if="p.acao === 'cadastrar_vincular'" layout="green-go" @click="$emit('cadastrar', p)") CADASTRAR E VINCULAR
        Button.vincular(v-else-if="p.acao === 'vincular'" layout="green-go" @click="$emit('vincular', p)") VINCULAR
        Button.excecao(v-else-if="p.acao === 'excecao' && podeExcecao" layout="green-go" @click="$emit('excecao', p)") CONCEDER EXCEÇÃO
        Button.ativar(v-else-if="p.acao === 'ativar'" layout="green-go" @click="ativar(p)" :loader="bloader") ATIVAR
</template>

<script>
import { mapActions, mapMutations } from "vuex";
import Button from "@/components/Button";
import Loader from "@/components/Loader";

const ROTULOS = {
  sem_cadastro: "Sem cadastro", sem_vinculo: "Sem vínculo", suspenso: "Suspenso",
  bloqueado: "Bloqueado", desativado: "Desativado", recusa_cadastro: "Cadastro recusado",
}

// Matrículas que travam job por causa do cadastro de login V.texp (sc-9881), no topo da aba
// de usuários V.texp. Situação, ação, dono e motivo vêm prontos do backend; aqui só se escolhe
// o botão. Cadastrar, vincular e exceção são do pai (eventos); ativar resolve-se aqui. A linha
// sem botão não some: a operação precisa saber a quem cobrar. O pai pede a recarga depois de
// uma ação incrementando `recarga`.
export default {
  name: "PendenciasTecnico",
  components: { Button, Loader },
  props: {
    podeExcecao: { type: Boolean, default: false },
    recarga: { type: Number, default: 0 },
  },
  data() {
    return { carregando: false, lista: [], bloader: false };
  },
  mounted() {
    this.carregar()
  },
  watch: {
    recarga: "carregar",
  },
  methods: {
    ...mapActions("admin", ["VTEXP_PENDENCIAS", "VTEXP_ATIVA"]),
    ...mapMutations("general", ["SET_STATUS"]),
    rotulo(situacao) { return ROTULOS[situacao] || situacao },
    semAcao(p) { return p.acao === "nenhuma" || (p.acao === "excecao" && !this.podeExcecao) },
    async carregar() {
      this.carregando = true
      const r = await this.VTEXP_PENDENCIAS()
      if (r.status == 200) this.lista = r.data
      this.carregando = false
    },
    async ativar(p) {
      if (!window.confirm(`Ativar o login ${p.matricula} de ${p.nome_vtexp}?`)) return
      this.bloader = true
      const r = await this.VTEXP_ATIVA(p.id_vtexp_doutor)
      this.bloader = false
      if (!r || r.status != 200) return
      this.SET_STATUS({ text: `Login ${p.matricula} ativado. O robô associa o técnico às atividades na próxima execução.`, color: "green" })
      await this.carregar()
    },
  },
};
</script>

<style lang="sass" scoped>
@use "sass:color"
@use "@/assets/scss/vars.scss" as *
.pendencias-tecnico
  .cabecalho
    margin-bottom: 16px
    h3
      margin: 0
      font-size: 15px
      letter-spacing: .5px
    .sub
      flex: 1
      color: $gray-5
      font-size: 12px
      margin: 0 14px
  label
    @include label
  .vazio
    padding: 28px 10px
    text-align: center
    color: $gray-5
    b
      display: block
      color: $green-6
      font-size: 16px
      margin-bottom: 4px
  .lista
    max-height: 50vh
    overflow: auto
  .pendencia
    border: 1.6px solid #ccc
    border-radius: 12px
    padding: 14px 18px
    margin-top: 10px
    background: white
    &:hover
      border-color: $purple
    &.sem-acao
      background: rgba($orange-1, .15)
      border-style: dashed
      .dono b
        color: color.adjust($orange-1, $lightness: -25%)
        font-size: 13px
    b
      font-size: 15px
    small
      color: $gray-5
      font-size: 12px
      line-height: 1.4
    .numero
      font-size: 22px
      color: $purple
    .situacao
      color: $purple
    .motivo
      color: $gray-9
    .dono b
      font-size: 12px
    .login
      font-family: monospace
    .button
      margin-left: 8px
</style>
